import React from 'react';
import { Avatar } from '@mui/material';
import { getAvatarInitials } from '../utils/avatar';
import { getApiBaseUrl } from '../utils/apiConfig';

const API_BASE_URL = getApiBaseUrl();

function UserAvatar({ name, online = false, away = false, size = 40, profilePictureUrl = null }) {
  const initials = getAvatarInitials(name);

  // Determine border color: green for online, orange for away, none for offline
  let borderColor = 'transparent';
  let showBorder = false;
  if (online && !away) {
    borderColor = 'success.main';
    showBorder = true;
  } else if (online && away) {
    borderColor = 'warning.main'; // Orange color
    showBorder = true;
  }

  // Build full URL for profile picture if provided
  const fullProfilePictureUrl = profilePictureUrl 
    ? `${API_BASE_URL.replace('/api', '')}${profilePictureUrl}`
    : null;

  return (
    <Avatar
      src={fullProfilePictureUrl || undefined}
      sx={{
        width: size,
        height: size,
        bgcolor: online ? 'primary.main' : 'grey.500',
        border: showBorder ? '2px solid' : 'none',
        borderColor: borderColor,
        fontSize: size < 40 ? '0.875rem' : '1.25rem',
      }}
    >
      {!fullProfilePictureUrl && initials}
    </Avatar>
  );
}

export default UserAvatar;

